import styled, { css, keyframes } from 'styled-components'

import { colors } from '../../../shared/styles/colors'

interface IContainerProps {
  openModal: boolean
}

interface IContentContainerProps {
  $size: 'small' | 'medium' | 'large' | 'unset'
  $curvature?: string
  $margin?: string
}

const apperFromLeft = keyframes`
    from {
        opacity: 0;
        transform: translateY(-100px)
    }

    to {
        opacity: 1;
        transform: translateY(0px)
    }
`

export const Container = styled.div<IContainerProps>`
  display: none;
  position: fixed;
  z-index: 999;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  overflow-y: auto;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.4);

  ${props =>
    props.openModal &&
    css`
      display: flex;
      align-items: center;
      justify-content: center;
    `}
`

export const ContentContainer = styled.div<IContentContainerProps>`
  background-color: ${colors.white};

  border-radius: 8px;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  animation: ${apperFromLeft} 0.3s;
  margin: ${props => props.$margin};

  ${props =>
    props.$size === 'small' &&
    css`
      width: 563px;
      height: 335px;
    `}

  ${props =>
    props.$size === 'medium' &&
    css`
      width: 563px;
      height: 404px;
    `}

  ${props =>
    props.$size === 'large' &&
    css`
      width: 859px;
      height: 613px;
    `}


  background-image: url(${props => props.$curvature});
  background-repeat: no-repeat;
`

interface IContainerHeaderProps {
  showCloseButtonBottom?: boolean
}

export const ContainerHeader = styled.div<IContainerHeaderProps>`
  display: flex;

  justify-content: ${props =>
    props.showCloseButtonBottom ? 'space-between' : 'flex-end'};

  width: 100%;
`

interface IContainerDetailProps {
  overflowY?: 'visible' | 'hidden' | 'clip' | 'scroll' | 'auto'
}

export const ContainerDetail = styled.div<IContainerDetailProps>`
  display: flex;
  flex: 1;

  flex-direction: column;
  align-items: center;

  padding: 20px;

  width: 100%;

  overflow-y: ${props => props.overflowY};
`

export const Title = styled.h1`
  font-size: 24px;
  font-weight: 700;
  color: ${colors.grayDark};
  margin-bottom: 16px;
  padding-left: 16px;
  padding-top: 16px;
`

export const ContainerButton = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  padding: 16px;
`
